import { Box, DashboardModule } from '@domain-group/suit-theme'

import { useFilters } from '@domain-group/react-hooks'

import useAgencyOrderBundles from '@hooks/useAgencyOrderBundles'
import useSelectEntities from '@hooks/useSelectEntities'

import DashboardModuleFilters from '@components/DashboardModuleFilters'
import ScopedConditionalContent from '@components/ScopedConditionalContent'

import AgencyOrderBundleListItem from './AgencyOrderBundleListItem'

const buildPageFilterFields = () => {
  const style = {
    marginBottom: 16,
  }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'order_bundle_string',
      label: 'Order Bundle Title or ID',
    },
  ]
}

interface AgencyOrderBundlesProps {
  agencyId: number,
}

const AgencyOrderBundles = (props: AgencyOrderBundlesProps) => {
  const { agencyId } = props

  const filterPayload = useFilters()
  const {
    pageFilters,
  } = filterPayload

  const agencyOrderBundlesPayload = useAgencyOrderBundles({
    filters: { ...pageFilters, agency_id: agencyId },
    performHttpRequests: !!agencyId,
    requestOptions: {
      include_agency_order_bundle_order_bundle: true,
    },
    sortKey: 'order_bundle_id',
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredAgencyOrderBundlesCount,
    filteredAgencyOrderBundles,
    hasFilteredAgencyOrderBundles,
    loading,
  } = agencyOrderBundlesPayload

  const unselectEntitiesPayload = useSelectEntities()
  const {
    callbacks: {
      getSelectableListItemProps,
    },
  } = unselectEntitiesPayload

  return (
    <DashboardModule
      boxProps={{ id: 'realhub-nav-bundles' }}
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={<DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title="Bundles"
    >
      <DashboardModuleFilters
        filterFields={buildPageFilterFields()}
        {...filterPayload}
      />

      <Box flexDirection="column">
        {!loading && !hasFilteredAgencyOrderBundles && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Order Bundles present
            </DashboardModule.BlankState.Title>

            <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support']}>
              <DashboardModule.BlankState.Paragraph>
                Please assign a Order Bundle
              </DashboardModule.BlankState.Paragraph>
            </ScopedConditionalContent>
          </DashboardModule.BlankState>
        )}

        {!loading && hasFilteredAgencyOrderBundles && (
          // @ts-expect-error TS2322
          <DashboardModule.ScrollableSection maxHeight={600}>
            {filteredAgencyOrderBundles.map((agencyOrderBundle) => {
              const { id } = agencyOrderBundle
              const listItemProps = getSelectableListItemProps(id)

              return (
                <AgencyOrderBundleListItem
                  agencyOrderBundle={agencyOrderBundle}
                  key={id}
                  {...listItemProps}
                />
              )
            })}
          </DashboardModule.ScrollableSection>
        )}

        <DashboardModule.LoadMoreFooter
          boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
          callbacks={{ loadMore }}
          canLoadMore={canLoadMore}
          entityCount={filteredAgencyOrderBundlesCount}
          loading={loading}
        />
      </Box>
    </DashboardModule>
  )
}

export default AgencyOrderBundles
